import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Devices"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 2.25H5.25C4.42157 2.25 3.75 2.92157 3.75 3.75V8.25H5.25V3.75H21.75V14.25H11.25V15.75H12.75V18.75H11.25V20.25H18V18.75H14.25V15.75H21.75C22.5784 15.75 23.25 15.0784 23.25 14.25V3.75C23.25 2.92157 22.5784 2.25 21.75 2.25ZM3 22.5C2.17157 22.5 1.5 21.8284 1.5 21V12C1.5 11.1716 2.17157 10.5 3 10.5H7.5C8.32843 10.5 9 11.1716 9 12V21C9 21.8284 8.32843 22.5 7.5 22.5H3ZM3 21V12H7.5V21H3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Devices.vue"]]);
